import { routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { applyMiddleware, compose, createStore, Store, StoreEnhancer } from 'redux';
import promiseMiddleware from 'redux-promise-middleware';
import thunk from 'redux-thunk';
import { getReducer } from './Reducer';
import { EnvironmentNames } from 'enuns/EnvironmentNames';

export const history = createBrowserHistory();

declare global {
  interface Window { __REDUX_DEVTOOLS_EXTENSION_COMPOSE__: Function; }
}

const devTools: Function = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const middleware: StoreEnhancer = applyMiddleware(
  routerMiddleware(history),
  thunk,
  promiseMiddleware
);

const getMiddleware = (env: EnvironmentNames) => {
  return env === 'production' ? middleware : devTools(middleware);
}

const getStore = (env: EnvironmentNames): Store => {
  return createStore(getReducer(), getMiddleware(env));
}

export { getStore };

